/**
 * The two ways to regenerate before saving (Spec § 3.2-5): `draft` runs only
 * the LLM leg on the current transcript, `transcript` transcribes the audio
 * again and then drafts from the new transcript.
 */
export var RegenerationMode;
(function (RegenerationMode) {
    RegenerationMode["DRAFT"] = "draft";
    RegenerationMode["TRANSCRIPT"] = "transcript";
})(RegenerationMode || (RegenerationMode = {}));
//# sourceMappingURL=regeneration-mode.enum.js.map